import React from 'react';

/**
 * Reusable pill that shows the current dock-leveler position
 * for a gate flagged `is_continuous_with_leveler`. Returns null
 * for any other gate so callers can mount it unconditionally
 * and let the component decide whether to render.
 *
 * Designed to sit alongside HermeticLockIndicator in the gate
 * detail card — same visual language, same vertical rhythm.
 */
function LevelerStatusIndicator({ isLevelerGate, levelerState, levelerStateChangedAt }) {
  if (!isLevelerGate) return null;

  const working = levelerState === 'working';
  const label = working ? 'בעבודה' : 'במנוחה';
  const colors = working
    ? { bg: '#fff7ed', border: '#fb923c', fg: '#9a3412', icon: '🚚' }
    : { bg: '#f0fdf4', border: '#86efac', fg: '#166534', icon: '⏸' };

  let since = null;
  if (levelerStateChangedAt) {
    const ms = Date.now() - new Date(levelerStateChangedAt).getTime();
    if (ms >= 0) {
      const minutes = Math.floor(ms / 60000);
      if (minutes < 60) {
        since = `${minutes} דק'`;
      } else {
        const h = Math.floor(minutes / 60);
        const r = minutes % 60;
        since = r ? `${h} ש' ${r} דק'` : `${h} ש'`;
      }
    }
  }

  return (
    <div style={{
      margin: '0.65rem 0',
      padding: '0.5rem 0.7rem',
      borderRadius: '8px',
      background: colors.bg,
      border: `1px solid ${colors.border}`,
      color: colors.fg,
      fontSize: '0.88rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    }}>
      <span style={{ fontSize: '1.1rem' }}>{colors.icon}</span>
      <span style={{ fontWeight: 600 }}>משווה גובה: {label}</span>
      {since && (
        <span style={{ opacity: 0.75, fontSize: '0.82rem' }}>· מזה {since}</span>
      )}
    </div>
  );
}

export default LevelerStatusIndicator;
